"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import clsx from "clsx";
import React, { useState } from "react";
export default function ProcessTabs(props) {
    var _useState = _sliced_to_array(useState(0), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 pb-6 relative pt-11 md:pt-20 overflow-hidden bg-gray-30 white-triangle white-triangle-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 md:mb-12 lg:mb-16"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto mb-3 text-center font-medium max-w-xs md:max-w-md lg:max-w-lg block text-2xl md:text-3xl lg:text-4xl"
    }, props.heading), props.description ? /*#__PURE__*/ React.createElement("p", {
        className: "mb-4 md:mb-8 lg:text-lg xl:text-xl text-center mx-auto max-w-xl lg:max-w-3xl"
    }, props.description) : null), /*#__PURE__*/ React.createElement("div", {
        className: "relative pb-3 lg:pb-14"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "md:flex w-full md:pb-10 lg:pb-16 max-[767px]:order-last mt-4 md:mt-2"
    }, props.tabs.map(function(tab, index) {
        /*#__PURE__*/ return React.createElement("li", {
            key: index,
            className: clsx("w-full items-start mt-1 mb-3 md:relative top-px cursor-pointer border-b-4 border-b-blue-500 font-heading flex lg:text-lg xl:text-xl transition-all flex-1", {
                "text-white bg-blue-500": index === selectedTab,
                "bg-transparent text-gray-200": index !== selectedTab
            })
        }, /*#__PURE__*/ React.createElement("button", {
            className: "text-center flex font-medium w-full px-2 py-2.5 md:pt-3.5 md:pb-3 focus focus-visible:-outline-offset-4 focus-visible:outline-black ".concat(selectedTab === index ? "bg-blue-500 text-white" : "text-gray-200"),
            onClick: function() {
                return tab && setSelectedTab(index);
            }
        }, /*#__PURE__*/ React.createElement("span", {
            className: "top-[84px] left-0 w-full"
        }, tab === null || tab === void 0 ? void 0 : tab.title)));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "relative mt-2"
    }, props.tabs.map(function(tab, index) {
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: clsx("top-0 left-0 w-full h-full opacity-0 transition-opacity duration-200", {
                "opacity-100 static": selectedTab === index,
                "absolute opacity-0": selectedTab !== index
            })
        }, /*#__PURE__*/ React.createElement("img", {
            src: tab === null || tab === void 0 ? void 0 : tab.image,
            alt: "",
            className: "knime-hidden md:block w-full h-auto"
        }), /*#__PURE__*/ React.createElement("img", {
            src: tab === null || tab === void 0 ? void 0 : tab.mobileImage,
            alt: "",
            className: "block md:hidden w-full h-auto"
        }));
    }))))));
}
